import { render, staticRenderFns } from "./RegisterRiderIdenCard.vue?vue&type=template&id=60c6ce92&scoped=true"
import script from "./RegisterRiderIdenCard.vue?vue&type=script&lang=js"
export * from "./RegisterRiderIdenCard.vue?vue&type=script&lang=js"
import style0 from "./RegisterRiderIdenCard.vue?vue&type=style&index=0&id=60c6ce92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6ce92",
  null
  
)

export default component.exports